module.exports = __webpack_public_path__ + "img/pen.a257aeb5.svg";